import { gql } from '@apollo/client';

export const GetAmcrFindPreviewsQueryName = 'GetAmcrFindPreviews';

export const GET_AMCR_FIND_PREVIEWS_QUERY = gql`
  query ${GetAmcrFindPreviewsQueryName}($findIds: [ID!]!) {
    getAmcrFindPreviews(findIds: $findIds) {
      findId
      projectIds
      record {
        projectId
        type {
          id
          label
        }
        material {
          id
          label
        }
        era {
          id
          label
        }
        context {
          id
          label
        }
        accessibility {
          id
          label
        }
        depth
        count
        note
        localization
        foundOn
        latitude
        longitude
        finder {
          id
          name
        }
      }
      errors {
        error
        path
      }
    }
  }
`;
